import { styled } from "@givenwell/stitches";
import { colors } from "@givenwell/theme";

export const Separator = styled("hr", {
  backgroundColor: colors.outline,
  border: 0,
  h: 1,
  w: "100%",
});
